import Vue from 'vue'
import VuePdfApp from 'vue-pdf-app'
Vue.component('vue-pdf', VuePdfApp)
